import React from "react";
import { Link } from "react-router-dom";
import avatar from "../images/amanda-selfie.jpeg";
import NameLogo from "./NameLogo";

const Bio = () => {
  return (
    <div>
      <div className="logo-pages">
        <NameLogo />
      </div>
      <div className="inner-container-bio">
        <img src={avatar} alt="avatar" className="avatar center"></img>
        <div id="full-name">
          <p>Amanda de Paula (Reis)</p>
        </div>

        <div id="bio-p">
          <p id="bio-p">(she/her)</p>
          Hi! My name is Amanda, and I am front end engineer currently based in
          San Francisco, Ca. My passions include coffee, React.js, minimalistic
          design, chocolate and fine wine.
          <div className="current-project" style={{ textAlign: "center" }}>
            <p>Ongoing project:</p>
            <a
              href="https://exploretravel.tips"
              rel="noreferrer"
              target="_blank"
            >
              www.exploretravel.tips
            </a>
            <br />
            <a
              href="https://manda-weather-app.herokuapp.com/"
              rel="noreferrer"
              target="_blank"
            >
              Weather App
            </a>
          </div>
          <div className="lg-icons">
            <svg
              viewBox="0 0 130 130"
              width="50"
              height="50"
              style={{ marginRight: "12px" }}
            >
              <path
                fill="#F0DB4F"
                d="M1.408 1.408h125.184v125.185h-125.184z"
              ></path>
              <path
                fill="#323330"
                d="M116.347 96.736c-.917-5.711-4.641-10.508-15.672-14.981-3.832-1.761-8.104-3.022-9.377-5.926-.452-1.69-.512-2.642-.226-3.665.821-3.32 4.784-4.355 7.925-3.403 2.023.678 3.938 2.237 5.093 4.724 5.402-3.498 5.391-3.475 9.163-5.879-1.381-2.141-2.118-3.129-3.022-4.045-3.249-3.629-7.676-5.498-14.756-5.355l-3.688.477c-3.534.893-6.902 2.748-8.877 5.235-5.926 6.724-4.236 18.492 2.975 23.335 7.104 5.332 17.54 6.545 18.873 11.531 1.297 6.104-4.486 8.08-10.234 7.378-4.236-.881-6.592-3.034-9.139-6.949-4.688 2.713-4.688 2.713-9.508 5.485 1.143 2.499 2.344 3.63 4.26 5.795 9.068 9.198 31.76 8.746 35.83-5.176.165-.478 1.261-3.666.38-8.581zm-46.885-37.793h-11.709l-.048 30.272c0 6.438.333 12.34-.714 14.149-1.713 3.558-6.152 3.117-8.175 2.427-2.059-1.012-3.106-2.451-4.319-4.485-.333-.584-.583-1.036-.667-1.071l-9.52 5.83c1.583 3.249 3.915 6.069 6.902 7.901 4.462 2.678 10.459 3.499 16.731 2.059 4.082-1.189 7.604-3.652 9.448-7.401 2.666-4.915 2.094-10.864 2.07-17.444.06-10.735.001-21.468.001-32.237z"
              ></path>
            </svg>
            <svg
              viewBox="0 0 130 130"
              width="50"
              height="50"
              style={{ marginRight: "12px" }}
            >
              <g fill="#61DAFB">
                <circle cx="64" cy="64" r="11.4"></circle>
                <path d="M107.3 45.2c-2.2-.8-4.5-1.6-6.9-2.3.6-2.4 1.1-4.8 1.5-7.1 2.1-13.2-.2-22.5-6.6-26.1-1.9-1.1-4-1.6-6.4-1.6-7 0-15.9 5.2-24.9 13.9-9-8.7-17.9-13.9-24.9-13.9-2.4 0-4.5.5-6.4 1.6-6.4 3.7-8.7 13-6.6 26.1.4 2.3.9 4.7 1.5 7.1-2.4.7-4.7 1.4-6.9 2.3-12.5 4.8-19.3 11.4-19.3 18.8s6.9 14 19.3 18.8c2.2.8 4.5 1.6 6.9 2.3-.6 2.4-1.1 4.8-1.5 7.1-2.1 13.2.2 22.5 6.6 26.1 1.9 1.1 4 1.6 6.4 1.6 7.1 0 16-5.2 24.9-13.9 9 8.7 17.9 13.9 24.9 13.9 2.4 0 4.5-.5 6.4-1.6 6.4-3.7 8.7-13 6.6-26.1-.4-2.3-.9-4.7-1.5-7.1 2.4-.7 4.7-1.4 6.9-2.3 12.5-4.8 19.3-11.4 19.3-18.8s-6.8-14-19.3-18.8zm-14.8-30.5c4.1 2.4 5.5 9.8 3.8 20.3-.3 2.1-.8 4.3-1.4 6.6-5.2-1.2-10.7-2-16.5-2.5-3.4-4.8-6.9-9.1-10.4-13 7.4-7.3 14.9-12.3 21-12.3 1.3 0 2.5.3 3.5.9zm-11.2 59.3c-1.8 3.2-3.9 6.4-6.1 9.6-3.7.3-7.4.4-11.2.4-3.9 0-7.6-.1-11.2-.4-2.2-3.2-4.2-6.4-6-9.6-1.9-3.3-3.7-6.7-5.3-10 1.6-3.3 3.4-6.7 5.3-10 1.8-3.2 3.9-6.4 6.1-9.6 3.7-.3 7.4-.4 11.2-.4 3.9 0 7.6.1 11.2.4 2.2 3.2 4.2 6.4 6 9.6 1.9 3.3 3.7 6.7 5.3 10-1.7 3.3-3.4 6.6-5.3 10zm8.3-3.3c1.5 3.5 2.7 6.9 3.8 10.3-3.4.8-7 1.4-10.8 1.9 1.2-1.9 2.5-3.9 3.6-6 1.2-2.1 2.3-4.2 3.4-6.2zm-25.6 27.1c-2.4-2.6-4.7-5.4-6.9-8.3 2.3.1 4.6.2 6.9.2 2.3 0 4.6-.1 6.9-.2-2.2 2.9-4.5 5.7-6.9 8.3zm-18.6-15c-3.8-.5-7.4-1.1-10.8-1.9 1.1-3.3 2.3-6.8 3.8-10.3 1.1 2 2.2 4.1 3.4 6.1 1.2 2.2 2.4 4.1 3.6 6.1zm-7-25.5c-1.5-3.5-2.7-6.9-3.8-10.3 3.4-.8 7-1.4 10.8-1.9-1.2 1.9-2.5 3.9-3.6 6-1.2 2.1-2.3 4.2-3.4 6.2zm25.6-27.1c2.4 2.6 4.7 5.4 6.9 8.3-2.3-.1-4.6-.2-6.9-.2-2.3 0-4.6.1-6.9.2 2.2-2.9 4.5-5.7 6.9-8.3zm22.2 21l-3.6-6c3.8.5 7.4 1.1 10.8 1.9-1.1 3.3-2.3 6.8-3.8 10.3-1.1-2.1-2.2-4.2-3.4-6.2zm-54.5-16.2c-1.7-10.5-.3-17.9 3.8-20.3 1-.6 2.2-.9 3.5-.9 6 0 13.5 4.9 21 12.3-3.5 3.8-7 8.2-10.4 13-5.8.5-11.3 1.4-16.5 2.5-.6-2.3-1-4.5-1.4-6.6zm-24.7 29c0-4.7 5.7-9.7 15.7-13.4 2-.8 4.2-1.5 6.4-2.1 1.6 5 3.6 10.3 6 15.6-2.4 5.3-4.5 10.5-6 15.5-13.8-4-22.1-10-22.1-15.6zm28.5 49.3c-4.1-2.4-5.5-9.8-3.8-20.3.3-2.1.8-4.3 1.4-6.6 5.2 1.2 10.7 2 16.5 2.5 3.4 4.8 6.9 9.1 10.4 13-7.4 7.3-14.9 12.3-21 12.3-1.3 0-2.5-.3-3.5-.9zm60.8-20.3c1.7 10.5.3 17.9-3.8 20.3-1 .6-2.2.9-3.5.9-6 0-13.5-4.9-21-12.3 3.5-3.8 7-8.2 10.4-13 5.8-.5 11.3-1.4 16.5-2.5.6 2.3 1 4.5 1.4 6.6zm9-15.6c-2 .8-4.2 1.5-6.4 2.1-1.6-5-3.6-10.3-6-15.6 2.4-5.3 4.5-10.5 6-15.5 13.8 4 22.1 10 22.1 15.6 0 4.7-5.8 9.7-15.7 13.4z"></path>
              </g>
            </svg>
            <svg
              viewBox="0 0 130 130"
              width="50"
              height="50"
              style={{ marginRight: "12px" }}
            >
              <linearGradient
                id="a"
                gradientUnits="userSpaceOnUse"
                x1="157.08"
                y1="2382.05"
                x2="131.682"
                y2="2426.892"
                gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
              >
                <stop offset="0" stop-color="#FB7655"></stop>
                <stop offset="0" stop-color="#FB7655"></stop>
                <stop offset=".41" stop-color="#E42B1E"></stop>
                <stop offset=".99" stop-color="#900"></stop>
                <stop offset="1" stop-color="#900"></stop>
              </linearGradient>
              <path
                fill="url(#a)"
                d="M97.078 83.214l-68.738 40.817 89.003-6.04 6.855-89.745z"
              ></path>
              <linearGradient
                id="b"
                gradientUnits="userSpaceOnUse"
                x1="169.731"
                y1="2419.72"
                x2="136.998"
                y2="2441.685"
                gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
              >
                <stop offset="0" stop-color="#871101"></stop>
                <stop offset="0" stop-color="#871101"></stop>
                <stop offset=".99" stop-color="#911209"></stop>
                <stop offset="1" stop-color="#911209"></stop>
              </linearGradient>
              <path
                fill="url(#b)"
                d="M117.488 117.93l-7.649-52.799-20.837 27.514z"
              ></path>
              <linearGradient
                id="c"
                gradientUnits="userSpaceOnUse"
                x1="143.542"
                y1="2380.69"
                x2="110.81"
                y2="2402.655"
                gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
              >
                <stop offset="0" stop-color="#871101"></stop>
                <stop offset="0" stop-color="#871101"></stop>
                <stop offset=".99" stop-color="#911209"></stop>
                <stop offset="1" stop-color="#911209"></stop>
              </linearGradient>
              <path
                fill="url(#c)"
                d="M117.592 117.93l-56.044-4.399-32.91 10.385z"
              ></path>
              <linearGradient
                id="d"
                gradientUnits="userSpaceOnUse"
                x1="74.817"
                y1="2435.622"
                x2="79.891"
                y2="2402.644"
                gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
              >
                <stop offset="0" stop-color="#fff"></stop>
                <stop offset="0" stop-color="#fff"></stop>
                <stop offset=".23" stop-color="#E57252"></stop>
                <stop offset=".46" stop-color="#DE3B20"></stop>
                <stop offset=".99" stop-color="#A60003"></stop>
                <stop offset="1" stop-color="#A60003"></stop>
              </linearGradient>
              <path
                fill="url(#d)"
                d="M28.717 123.928l14.001-45.867-30.81 6.588z"
              ></path>
              <linearGradient
                id="e"
                gradientUnits="userSpaceOnUse"
                x1="109.719"
                y1="2466.413"
                x2="111.589"
                y2="2432.757"
                gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
              >
                <stop offset="0" stop-color="#fff"></stop>
                <stop offset="0" stop-color="#fff"></stop>
                <stop offset=".23" stop-color="#E4714E"></stop>
                <stop offset=".56" stop-color="#BE1A0D"></stop>
                <stop offset=".99" stop-color="#A80D00"></stop>
                <stop offset="1" stop-color="#A80D00"></stop>
              </linearGradient>
              <path
                fill="url(#e)"
                d="M88.996 92.797l-12.882-50.46-36.866 34.558z"
              ></path>
              <linearGradient
                id="f"
                gradientUnits="userSpaceOnUse"
                x1="140.691"
                y1="2497.523"
                x2="146.289"
                y2="2473.401"
                gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
              >
                <stop offset="0" stop-color="#fff"></stop>
                <stop offset="0" stop-color="#fff"></stop>
                <stop offset=".18" stop-color="#E46342"></stop>
                <stop offset=".4" stop-color="#C82410"></stop>
                <stop offset=".99" stop-color="#A80D00"></stop>
                <stop offset="1" stop-color="#A80D00"></stop>
              </linearGradient>
              <path
                fill="url(#f)"
                d="M121.275 43.047l-34.849-28.462-9.704 31.373z"
              ></path>
              <linearGradient
                id="g"
                gradientUnits="userSpaceOnUse"
                x1="123.6"
                y1="2506.018"
                x2="147.719"
                y2="2518.077"
                gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
              >
                <stop offset="0" stop-color="#fff"></stop>
                <stop offset="0" stop-color="#fff"></stop>
                <stop offset=".54" stop-color="#C81F11"></stop>
                <stop offset=".99" stop-color="#BF0905"></stop>
                <stop offset="1" stop-color="#BF0905"></stop>
              </linearGradient>
              <path
                fill="url(#g)"
                d="M104.978 4.437l-20.497 11.327-12.93-11.479z"
              ></path>
              <linearGradient
                id="h"
                gradientUnits="userSpaceOnUse"
                x1="53.674"
                y1="2444.028"
                x2="55.66"
                y2="2424.153"
                gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
              >
                <stop offset="0" stop-color="#fff"></stop>
                <stop offset="0" stop-color="#fff"></stop>
                <stop offset=".31" stop-color="#DE4024"></stop>
                <stop offset=".99" stop-color="#BF190B"></stop>
                <stop offset="1" stop-color="#BF190B"></stop>
              </linearGradient>
              <path
                fill="url(#h)"
                d="M3.802 100.034l8.586-15.659-6.946-18.655z"
              ></path>
              <path
                fill="#fff"
                d="M4.981 65.131l6.987 19.821 30.365-6.812 34.667-32.218 9.783-31.075-15.403-10.878-26.19 9.802c-8.252 7.675-24.263 22.86-24.84 23.146-.573.291-10.575 19.195-15.369 28.214z"
              ></path>
              <linearGradient
                id="i"
                gradientUnits="userSpaceOnUse"
                x1="40.026"
                y1="2418.781"
                x2="133.345"
                y2="2514.739"
                gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
              >
                <stop offset="0" stop-color="#BD0012"></stop>
                <stop offset="0" stop-color="#BD0012"></stop>
                <stop offset=".07" stop-color="#fff"></stop>
                <stop offset=".17" stop-color="#fff"></stop>
                <stop offset=".27" stop-color="#C82F1C"></stop>
                <stop offset=".33" stop-color="#820C01"></stop>
                <stop offset=".46" stop-color="#A31601"></stop>
                <stop offset=".72" stop-color="#B31301"></stop>
                <stop offset=".99" stop-color="#E82609"></stop>
                <stop offset="1" stop-color="#E82609"></stop>
              </linearGradient>
              <path
                fill="url(#i)"
                d="M29.519 29.521c17.882-17.73 40.937-28.207 49.785-19.28 8.843 8.926-.534 30.62-18.418 48.345-17.884 17.725-40.653 28.779-49.493 19.852-8.849-8.92.242-31.191 18.126-48.917z"
              ></path>
              <linearGradient
                id="j"
                gradientUnits="userSpaceOnUse"
                x1="111.507"
                y1="2409.102"
                x2="83.398"
                y2="2416.039"
                gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
              >
                <stop offset="0" stop-color="#8C0C01"></stop>
                <stop offset="0" stop-color="#8C0C01"></stop>
                <stop offset=".54" stop-color="#990C00"></stop>
                <stop offset=".99" stop-color="#A80D0E"></stop>
                <stop offset="1" stop-color="#A80D0E"></stop>
              </linearGradient>
              <path
                fill="url(#j)"
                d="M28.717 123.909l13.89-46.012 46.135 14.82c-16.68 15.642-35.233 28.865-60.025 31.192z"
              ></path>
              <linearGradient
                id="k"
                gradientUnits="userSpaceOnUse"
                x1="159.785"
                y1="2442.837"
                x2="134.814"
                y2="2465.217"
                gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
              >
                <stop offset="0" stop-color="#7E110B"></stop>
                <stop offset="0" stop-color="#7E110B"></stop>
                <stop offset=".99" stop-color="#9E0C00"></stop>
                <stop offset="1" stop-color="#9E0C00"></stop>
              </linearGradient>
              <path
                fill="url(#k)"
                d="M77.062 45.831l11.844 46.911c13.934-14.65 26.439-30.401 32.563-49.883l-44.407 2.972z"
              ></path>
              <linearGradient
                id="l"
                gradientUnits="userSpaceOnUse"
                x1="168.959"
                y1="2483.901"
                x2="156.521"
                y2="2497.199"
                gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
              >
                <stop offset="0" stop-color="#79130D"></stop>
                <stop offset="0" stop-color="#79130D"></stop>
                <stop offset=".99" stop-color="#9E120B"></stop>
                <stop offset="1" stop-color="#9E120B"></stop>
              </linearGradient>
              <path
                fill="url(#l)"
                d="M121.348 43.097c4.74-14.305 5.833-34.825-16.517-38.635l-18.339 10.13 34.856 28.505z"
              ></path>
              <path
                fill="#9E1209"
                d="M3.802 99.828c.656 23.608 17.689 23.959 24.945 24.167l-16.759-39.14-8.186 14.973z"
              ></path>
              <radialGradient
                id="m"
                cx="138.703"
                cy="2464.789"
                r="30.601"
                gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0" stop-color="#A80D00"></stop>
                <stop offset="0" stop-color="#A80D00"></stop>
                <stop offset=".99" stop-color="#7E0E08"></stop>
                <stop offset="1" stop-color="#7E0E08"></stop>
              </radialGradient>
              <path
                fill="url(#m)"
                d="M77.128 45.904c10.708 6.581 32.286 19.798 32.723 20.041.68.383 9.304-14.542 11.261-22.976l-43.984 2.935z"
              ></path>
              <radialGradient
                id="n"
                cx="96.325"
                cy="2424.465"
                r="40.679"
                gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0" stop-color="#A30C00"></stop>
                <stop offset="0" stop-color="#A30C00"></stop>
                <stop offset=".99" stop-color="#800E08"></stop>
                <stop offset="1" stop-color="#800E08"></stop>
              </radialGradient>
              <path
                fill="url(#n)"
                d="M42.589 77.897l18.57 35.828c10.98-5.955 19.579-13.211 27.454-20.983l-46.024-14.845z"
              ></path>
              <linearGradient
                id="o"
                gradientUnits="userSpaceOnUse"
                x1="67.509"
                y1="2393.115"
                x2="57.373"
                y2="2427.506"
                gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
              >
                <stop offset="0" stop-color="#8B2114"></stop>
                <stop offset="0" stop-color="#8B2114"></stop>
                <stop offset=".43" stop-color="#9E100A"></stop>
                <stop offset=".99" stop-color="#B3100C"></stop>
                <stop offset="1" stop-color="#B3100C"></stop>
              </linearGradient>
              <path
                fill="url(#o)"
                d="M11.914 84.904l-2.631 31.331c4.964 6.781 11.794 7.371 18.96 6.842-5.184-12.9-15.538-38.696-16.329-38.173z"
              ></path>
              <linearGradient
                id="p"
                gradientUnits="userSpaceOnUse"
                x1="145.272"
                y1="2507.076"
                x2="167.996"
                y2="2497.045"
                gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
              >
                <stop offset="0" stop-color="#B31000"></stop>
                <stop offset="0" stop-color="#B31000"></stop>
                <stop offset=".44" stop-color="#910F08"></stop>
                <stop offset=".99" stop-color="#791C12"></stop>
                <stop offset="1" stop-color="#791C12"></stop>
              </linearGradient>
              <path
                fill="url(#p)"
                d="M86.384 14.67l36.891 5.177c-1.969-8.343-8.015-13.727-18.32-15.41l-18.571 10.233z"
              ></path>
            </svg>
            <svg
              viewBox="0 0 130 130"
              width="50"
              height="50"
              style={{ marginRight: "12px" }}
            >
              <g fill="#A62C46">
                <path d="M18.922 104.532v21.468h5.476v-5.591l4.983 4.983h8.402l-6.664-6.664s4.795-.078 5.157-7.01c0-6.361-4.8-7.186-10.343-7.186h-7.011zm5.737 5.824h4.722v3.824h-4.722v-3.824z"></path>
                <path d="M48.358 104.619c-2.997-.017-7.155.261-7.155 5.911v14.92h5.62v-3.65h5.447v3.563h5.649v-15.644c0-4.907-5.452-5.1-8.373-5.1h-1.188zm-1.449 5.388h5.273v5.882h-5.273v-5.882z"></path>
                <path d="M63.55 104.632h5.815v20.537h-5.815z"></path>
                <path d="M75.454 104.905v20.537h13.995v-5.452h-8.269v-15.175l-5.726.09z"></path>
                <path d="M107.986 104.722v5.543h-9.36v1.999h3.999s6.453-.09 6.453 6.452c0 6.543-3 6.907-9.088 6.907h-7.36v-4.998h8.451c2.544 0 2.685-.829 2.685-1.551 0-.721-1.3-1.056-3.946-1.056s-7.553-1.301-7.553-6.389c0-5.089 2.545-6.998 7.633-6.998 5.088.001 8.086.091 8.086.091z"></path>
              </g>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#A62C46"
                d="M100.556 10.818c-9.749-4.811-19.734-5.3-29.958-1.687-9.408 3.326-16.913 9.277-22.491 17.381-9.44 13.716-16.296 28.682-20.141 44.938-1.966 8.322-3.241 16.304-2.898 24.897.028.698.131 1.653.2 1.653h48.214c-.137 0-.229-.288-.348-.593-2.536-6.475-4.545-12.891-5.933-19.705-1.995-9.784-3.039-19.541-.979-29.416 2.884-13.829 10.767-23.702 24.055-28.873 7.527-2.932 14.67-2.044 20.937 3.455.058.051.175.048.328.073l2.05-3.087c-3.946-3.758-8.282-6.69-13.036-9.036zM25.067 75.154l-9.45-.714-1.07 9.146 8.891 1.068 1.629-9.5zM33.069 47.135c-2.889-1.129-5.58-2.183-8.363-3.273-.928 2.638-1.794 5.093-2.704 7.675 2.919.936 5.668 1.817 8.524 2.731l2.543-7.133zM72.542 89.993c2.855.212 5.716.36 8.867.543-1.145-2.379-2.16-4.53-3.226-6.657-.116-.231-.51-.454-.777-.458-2.422-.035-4.847-.021-7.421-.021.579 2.1 1.084 4.035 1.674 5.945.088.288.563.624.883.648zM47.243 23.889l-6.353-4.207c-1.703 1.903-3.345 3.738-5.08 5.675l6.532 4.39 4.901-5.858zM67.477 66.515c-.009.257.222.665.446.767 2.289 1.028 4.601 2.008 7.119 3.093-.105-1.99-.176-3.654-.294-5.314-.022-.298-.163-.729-.384-.852-2.101-1.164-4.231-2.274-6.562-3.51-.128 2.129-.257 3.97-.325 5.816zM65.595 8.871l-4.35-4.936-5.989 3.113 4.356 5.307 5.983-3.484zM68.323 48.148c-.129.3.043.932.298 1.163 1.737 1.567 3.534 3.066 5.532 4.777.458-1.917.889-3.625 1.255-5.345.065-.307-.025-.813-.238-.983-1.555-1.254-3.159-2.446-4.822-3.716-.731 1.451-1.439 2.751-2.025 4.104zM78.267 6.276c2.22.062 4.443.034 6.788.034-.234-1.632-.345-2.87-.624-4.067-.083-.355-.621-.831-.982-.86-2.225-.181-4.46-.25-6.91-.367.327 1.647.576 3.099.928 4.526.076.304.518.728.8.734zM80.971 34.77c.113-.212.142-.598.023-.784-1.092-1.706-2.224-3.387-3.398-5.154l-3.803 3.491 5.259 5.827c.705-1.23 1.337-2.292 1.919-3.38zM85.071 23.168c.808 1.499 1.54 2.858 2.271 4.219 3.553-1.946 3.894-2.653 2.635-5.458l-4.906 1.239zM102.073 10.171c1.479.912 3.04 1.688 4.627 2.544l1.062-1.654-5.921-4.334c-.082.881-.206 1.499-.174 2.106.025.465.104 1.151.406 1.338zM106 21.868c-3-.351-4-.698-6-1.058v2.714c2 .173 3 .339 6 .513v-2.169z"
              ></path>
            </svg>

            <svg
              viewBox="0 0 130 130"
              width="50"
              height="50"
              style={{ marginRight: "12px" }}
            >
              <path
                fill="#5B4282"
                d="M75.701 65.603c-2.334-.768-5.694-.603-10.08-.603h-17.621v23h18.844c2.944 0 5.012-.315 6.203-.535 2.099-.376 3.854-1.104 5.264-1.982 1.409-.876 2.568-2.205 3.478-3.881.908-1.676 1.363-3.637 1.363-5.83 0-2.568-.658-4.54-1.975-6.436-1.316-1.896-3.141-2.965-5.476-3.733zM73.282 55.087c2.317-.688 4.064-1.89 5.239-3.487 1.176-1.598 1.763-3.631 1.763-6.044 0-2.286-.549-4.314-1.646-6.054s-2.662-2.413-4.699-3.056c-2.037-.641-5.53-.446-10.48-.446h-15.459v20h16.587c4.042 0 6.939-.38 8.695-.913zM126 18.625c0-9.182-7.443-16.625-16.625-16.625h-91.75c-9.182 0-16.625 7.443-16.625 16.625v91.75c0 9.182 7.443 16.625 16.625 16.625h91.75c9.182 0 16.625-7.443 16.625-16.625v-91.75zm-35.447 66.12c-1.362 2.773-3.047 4.911-5.052 6.415-2.006 1.504-4.521 2.78-7.544 3.548-3.022.769-6.728 1.292-11.113 1.292h-27.844v-69h27.42c5.264 0 9.485.609 12.665 2.002 3.181 1.395 5.671 3.497 7.474 6.395 1.801 2.898 2.702 5.907 2.702 9.071 0 2.945-.8 5.708-2.397 8.308-1.598 2.602-4.011 4.694-7.237 6.292 4.166 1.222 7.37 3.304 9.61 6.248 2.24 2.945 3.36 6.422 3.36 10.432 0 3.227-.681 6.225-2.044 8.997z"
              ></path>
            </svg>
            <svg
              viewBox="0 0 130 130"
              width="50"
              height="50"
              style={{ marginRight: "12px" }}
            >
              <path
                fill="#F34F29"
                d="M124.742 58.378l-55.117-55.114c-3.172-3.174-8.32-3.174-11.497 0l-11.443 11.446 14.518 14.518c3.375-1.139 7.243-.375 9.932 2.314 2.703 2.706 3.462 6.607 2.293 9.993l13.992 13.994c3.385-1.167 7.292-.413 9.994 2.295 3.78 3.777 3.78 9.9 0 13.679-3.78 3.78-9.901 3.78-13.683 0-2.842-2.844-3.545-7.019-2.105-10.521l-13.048-13.049-.002 34.341c.922.455 1.791 1.063 2.559 1.828 3.779 3.777 3.779 9.898 0 13.683-3.779 3.777-9.904 3.777-13.679 0-3.778-3.784-4.088-9.905-.311-13.683.934-.933 1.855-1.638 2.855-2.11v-34.659c-1-.472-1.92-1.172-2.856-2.111-2.861-2.86-3.396-7.06-1.928-10.576l-14.233-14.313-37.754 37.79c-3.175 3.177-3.155 8.325.02 11.5l55.126 55.114c3.173 3.174 8.325 3.174 11.503 0l54.86-54.858c3.175-3.176 3.178-8.327.004-11.501z"
              ></path>
            </svg>
            <svg
              viewBox="0 0 130 130"
              width="50"
              height="50"
              style={{ marginRight: "12px" }}
            >
              <path
                fill="#E44D26"
                d="M19.037 113.876l-10.005-112.215h109.936l-10.016 112.198-45.019 12.48z"
              ></path>
              <path
                fill="#F16529"
                d="M64 116.8l36.378-10.086 8.559-95.878h-44.937z"
              ></path>
              <path
                fill="#EBEBEB"
                d="M64 52.455h-18.212l-1.258-14.094h19.47v-13.762h-34.511l.33 3.692 3.382 37.927h30.799zM64 88.198l-.061.017-15.327-4.14-.979-10.975h-13.817l1.928 21.609 28.193 7.826.063-.017z"
              ></path>
              <path
                fill="#fff"
                d="M63.952 52.455v13.763h16.947l-1.597 17.849-15.35 4.143v14.319l28.215-7.82.207-2.325 3.234-36.233.335-3.696h-3.708zM63.952 24.599v13.762h33.244l.276-3.092.628-6.978.329-3.692z"
              ></path>
            </svg>
            <svg
              viewBox="0 0 130 130"
              width="50"
              height="50"
              style={{ marginRight: "15px" }}
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#336791"
                d="M123.258 76.784c-.45-2.918-2.901-4.829-5.752-4.958-1.032-.047-2.08.061-3.109.192-1.243.158-2.471.438-3.711.623-.857.128-1.726.187-2.582.275l-.021-.111c1.598-3.018 3.263-6.003 4.775-9.064 1.159-2.348 2.151-4.781 3.176-7.194 1.696-3.998 3.051-8.12 4.173-12.309 1.075-4.011 1.995-8.066 2.284-12.227.116-1.662.196-3.331.187-4.995-.008-1.327-.151-2.656-.284-3.979-.15-1.516-.608-2.953-1.242-4.336-.836-1.822-2.132-3.317-3.496-4.737-1.092-1.137-2.293-2.173-3.484-3.208-1.698-1.477-3.607-2.656-5.59-3.703-2.253-1.19-4.621-2.121-7.09-2.75-1.493-.381-3.02-.664-4.532-.966-.544-.11-1.089-.337-1.633-.337h-10.241c-.37 0-.737.191-1.11.233-2.452.273-4.875.735-7.228 1.464-.88.273-1.684.101-2.52.024-.641-.059-1.271-.231-1.912-.263-2.442-.122-4.887-.301-7.328-.275-2.339.024-4.654.409-6.918 1.052-1.895.538-3.749 1.195-5.447 2.191-.727.426-1.303.346-2.055.129-2.527-.729-5.072-1.414-7.639-1.989-1.6-.358-3.245-.536-4.879-.707-1.566-.163-3.144-.261-4.718-.294-1.538-.033-3.087-.032-4.618.104-2.439.217-4.832.713-7.158 1.513-2.583.888-4.951 2.175-7.086 3.865-2.167 1.715-3.905 3.809-5.303 6.2-1.473 2.523-2.483 5.224-3.111 8.061-.34 1.537-.555 3.117-.788 4.678-.073.486.732.972-.268 1.456v6.794c1 .452.208.903.266 1.356.139 1.089.262 2.187.446 3.268.291 1.711.636 3.417.988 5.117.491 2.375 1.002 4.748 1.546 7.111.396 1.72.847 3.43 1.319 5.131.721 2.598 1.431 5.201 2.246 7.77.757 2.387 1.624 4.74 2.484 7.093 1.191 3.255 2.617 6.405 4.327 9.424 1.479 2.614 3.169 5.062 5.436 7.076 1.494 1.327 3.157 2.347 5.093 2.857 1.521.4 3.067.448 4.624.129 1.805-.37 3.403-1.147 4.824-2.311.163-.134.342-.236.535.01.735.931 1.719 1.552 2.748 2.089 2.777 1.448 5.803 1.882 8.877 2.059.744.043 1.496-.064 2.246-.085 1.461-.04 2.881-.325 4.278-.729.732-.212 1.447-.481 2.192-.732.039.793.089 1.557.112 2.321l.104 4.166c.019.634.044 1.27.103 1.901.151 1.627.299 3.255.493 4.877.135 1.118.275 2.245.538 3.336.529 2.203 1.246 4.348 2.158 6.428.895 2.041 2.182 3.764 3.9 5.185 2.22 1.836 4.822 2.619 7.632 2.764 1.162.061 2.357.004 3.501-.204 1.813-.329 3.622-.743 5.387-1.275 3.591-1.084 6.695-2.956 9.014-5.981 1.32-1.724 2.404-3.589 3.1-5.648.574-1.701 1.115-3.419 1.545-5.16.34-1.372.508-2.787.715-4.188.137-.927.219-1.863.305-2.797.14-1.517.283-3.033.384-4.553.07-1.058.067-2.121.109-3.181.013-.323.065-.644.095-.966.028-.298.178-.401.482-.396 1.071.016 2.144.044 3.212-.004 1.197-.054 2.405-.105 3.583-.303 1.677-.281 3.346-.636 4.99-1.067 1.943-.508 3.725-1.418 5.44-2.455 1.998-1.207 3.819-2.623 5.297-4.447 1.285-1.591 1.894-3.43 1.584-5.438zm-3.412.982c-.066.915-.485 1.699-1.093 2.369-2.869 3.163-6.468 5.082-10.585 6.027-1.564.358-3.178.544-4.779.692-1.363.126-2.746.147-4.114.097-1.006-.038-2.004-.268-3.032-.416-.103.94-.201 1.919-.32 2.896l-.479 3.745c-.145 1.187-.258 2.378-.407 3.564-.146 1.151-.328 2.298-.481 3.449-.143 1.072-.248 2.149-.407 3.219-.245 1.64-.479 3.284-.799 4.911-.384 1.945-.973 3.829-1.934 5.583-1.172 2.141-2.834 3.772-4.949 4.98-2.18 1.246-4.563 1.894-6.979 2.436-1.71.384-3.472.447-5.204.291-3.004-.272-5.568-1.557-7.506-3.886-1.85-2.223-3.102-4.771-3.55-7.655-.214-1.371-.368-2.754-.491-4.136-.136-1.537-.229-3.079-.299-4.62-.089-1.957-.154-3.914-.197-5.871-.053-2.406-.07-4.812-.104-7.218l-.006-.092c-1.224.734-2.427 1.538-3.703 2.2-1.494.776-3.117 1.226-4.798 1.353-1.318.1-2.653.191-3.965.086-2.151-.173-4.3-.51-6.226-1.569-.781-.43-1.596-.953-2.134-1.64-1.29-1.646-.672-3.726 1.273-4.727 1.344-.693 2.811-.982 4.268-1.319 1.266-.293 2.526-.626 3.761-1.029 1.222-.4 1.993-1.391 2.754-2.363l1.206-1.551c-.503-.053-.977-.107-1.451-.151-1.439-.136-2.812-.532-4.125-1.114-1.124-.497-1.141-.551-1.965.343-1.376 1.494-2.714 3.023-4.062 4.542-.992 1.117-1.978 2.241-2.965 3.361-.978 1.108-1.894 2.279-2.947 3.31-1.564 1.531-3.449 2.452-5.698 2.348-1.443-.066-2.764-.572-3.952-1.399-2.452-1.708-4.104-4.097-5.608-6.606-1.927-3.215-3.406-6.64-4.672-10.159-.876-2.432-1.756-4.866-2.521-7.333-.831-2.681-1.56-5.396-2.277-8.11-.542-2.048-1.023-4.113-1.482-6.182-.521-2.353-1.022-4.71-1.464-7.079-.298-1.599-.471-3.221-.712-4.831-.325-2.17-.385-4.36-.267-6.539.105-1.963.387-3.921.667-5.871.388-2.698 1.277-5.244 2.556-7.648.783-1.473 1.755-2.812 2.879-4.056 1.845-2.042 4.078-3.518 6.562-4.626 1.736-.774 3.57-1.24 5.439-1.604 2.774-.54 5.573-.519 8.373-.461 1.224.025 2.443.248 3.666.369 2.633.262 5.214.816 7.762 1.5 1.857.498 3.676 1.143 5.518 1.703.185.056.456.051.607-.048 2.496-1.629 5.224-2.704 8.125-3.319 1.101-.233 2.237-.335 3.363-.407 1.369-.087 2.749-.167 4.115-.088 1.642.094 3.276.336 4.908.56.792.108 1.565.383 2.359.458.38.036.783-.242 1.185-.335 2.049-.473 4.089-1 6.156-1.374 1.539-.278 3.111-.409 4.676-.499 1.745-.1 3.503-.173 5.247-.089 2.205.106 4.394.42 6.555.923 2.677.623 5.245 1.528 7.686 2.784 1.824.938 3.558 2.026 5.119 3.364 1.023.878 2.07 1.745 2.994 2.723 1.14 1.206 2.303 2.413 3.018 3.958.538 1.165.922 2.371 1.028 3.647.132 1.586.292 3.178.277 4.766-.014 1.519-.221 3.037-.368 4.552-.334 3.454-1.085 6.833-1.997 10.167-.754 2.754-1.635 5.478-2.589 8.17-.879 2.481-1.893 4.917-2.918 7.343-.757 1.794-1.572 3.569-2.458 5.303-1.677 3.286-3.421 6.538-5.438 9.633-.348.535-.678 1.083-1.018 1.629.88.594 1.877.803 2.881.911.955.104 1.929.166 2.883.095 1.527-.113 3.049-.331 4.567-.544 1.504-.21 2.978-.638 4.522-.525 1.542.112 2.645 1.284 2.54 2.729zM97.833 74.413c-.655-.846-1.323-1.682-1.964-2.538-1.006-1.344-1.729-2.845-2.455-4.353-.688-1.429-1.532-2.782-2.257-4.195-1.265-2.465-2.553-4.922-3.718-7.435-1.465-3.157-2.62-6.426-2.984-9.923-.154-1.48-.193-2.958.106-4.424.479-2.341 1.702-4.172 3.758-5.428 1.907-1.165 4.032-1.541 6.209-1.659 1.351-.073 2.708-.013 4.11-.013l-.047-.237c-.872-1.823-1.687-3.677-2.641-5.457-1.346-2.512-3.068-4.777-4.986-6.877-1.421-1.555-2.96-2.998-4.646-4.273-1.658-1.255-3.405-2.376-5.269-3.293-2.223-1.093-4.538-1.938-6.967-2.477-2.334-.518-4.683-.835-7.077-.861-2.042-.022-4.071.07-6.06.531-3.002.695-5.748 1.931-8.137 3.933-1.334 1.118-2.498 2.373-3.517 3.77-1.196 1.643-2.161 3.417-2.986 5.277-1.132 2.552-1.909 5.208-2.44 7.938-.266 1.361-.474 2.734-.686 4.106-.074.48-.08.971-.123 1.521.369-.192.635-.34.907-.472l.885-.397c2.993-1.369 6.094-2.25 9.427-2.149 1.416.043 2.771.323 4.03.943 2.415 1.191 3.828 3.216 4.442 5.779.424 1.769.714 3.573.996 5.372.221 1.405.447 2.825.473 4.242.037 2.071-.068 4.146-.181 6.216-.096 1.764-.464 3.5-1.08 5.146-1.12 2.993-2.368 5.937-3.534 8.913-.385.983-.681 2.001-1.045 3.082.562 0 1.018-.004 1.474.002.178.003.36.008.532.049 1.34.316 2.502.923 3.455 1.954 1.271 1.372 1.938 2.973 1.972 4.826.019 1.027-.089 2.057-.084 3.084.021 4.786.057 9.572.097 14.357.007.782.046 1.565.102 2.346.117 1.635.235 3.271.395 4.902.112 1.157.268 2.312.451 3.461.259 1.628 1 3.077 1.841 4.462.724 1.191 1.665 2.203 2.905 2.901 2.107 1.186 4.376 1.285 6.663.848 1.545-.295 3.062-.769 4.562-1.258 1.479-.481 2.815-1.269 3.937-2.354 1.051-1.019 1.797-2.261 2.3-3.632.976-2.659 1.28-5.459 1.684-8.237.151-1.04.282-2.083.42-3.125.157-1.186.316-2.371.468-3.556.112-.883.214-1.768.322-2.651.154-1.268.317-2.535.464-3.804.113-.981.209-1.966.309-2.949.129-1.256.268-2.512.379-3.77.086-.955.051-1.927.22-2.864.311-1.718 1.123-3.18 2.646-4.125.637-.395 1.356-.655 2.063-.989l-.12-.186zM40.236 67.361c-.761-1.802-1.218-3.68-1.354-5.622-.128-1.825.089-3.643.276-5.46.182-1.76.333-3.528.386-5.296.088-2.906-.108-5.808-.247-8.712-.084-1.729.117-3.479.271-5.212.139-1.561.312-3.126.607-4.664.495-2.581 1.152-5.125 2.086-7.591.887-2.338 1.906-4.615 3.345-6.665.986-1.406 2.105-2.72 3.18-4.094l-.319-.113c-3.498-1.111-7.053-1.979-10.709-2.358-1.729-.179-3.464-.284-5.198-.387-.532-.032-1.072.04-1.606.091-1.322.126-2.66.176-3.961.424-2.214.421-4.338 1.129-6.305 2.282-1.766 1.035-3.249 2.373-4.491 3.978-1.372 1.772-2.295 3.776-2.958 5.913-.783 2.521-1.156 5.115-1.257 7.733-.088 2.295-.132 4.603.264 6.889.295 1.702.492 3.422.817 5.117.443 2.311.918 4.617 1.467 6.904.785 3.274 1.569 6.553 2.499 9.787.89 3.099 1.894 6.17 2.982 9.204.89 2.476 1.919 4.906 3.003 7.304.706 1.562 1.561 3.065 2.457 4.528.953 1.553 2.037 3.027 3.508 4.154 1.856 1.423 3.293 1.644 5.179.083.808-.669 1.491-1.495 2.194-2.282 1.117-1.25 2.195-2.534 3.307-3.788 1.416-1.598 2.85-3.179 4.273-4.769.301-.336.59-.682.883-1.022l-.484-.425c-1.769-1.699-3.139-3.669-4.095-5.931zM93.924 19.792c1.156 1.356 2.275 2.752 3.309 4.204 2 2.809 3.598 5.842 4.775 9.087.521 1.43.937 2.874.751 4.439-.129 1.096-.118 2.208-.215 3.31-.081.917-.226 1.829-.345 2.743-.178 1.378-.436 2.752-.513 4.136-.073 1.317.003 2.648.086 3.968.084 1.341.265 2.676.388 4.015.139 1.518.326 3.036.369 4.557.035 1.249-.076 2.506-.185 3.753-.13 1.502-.511 2.956-1.079 4.351-.399.982-.876 1.934-1.327 2.917l.181.192.275.213.277-.496c2.339-3.688 4.42-7.518 6.222-11.493 1.159-2.56 2.245-5.156 3.287-7.766 1.624-4.064 2.909-8.242 3.903-12.503.446-1.913.787-3.855 1.09-5.797.236-1.518.433-3.054.477-4.586.047-1.625-.043-3.263-.193-4.884-.112-1.224-.414-2.456-1.181-3.451-1.233-1.602-2.564-3.134-4.201-4.346-1.378-1.021-2.751-2.068-4.23-2.927-2.345-1.36-4.883-2.266-7.535-2.883-2.588-.603-5.21-.863-7.849-.918-1.556-.033-3.119.134-4.672.28-1.407.132-2.805.357-4.222.543 1.52.855 3.019 1.615 4.433 2.511 2.973 1.883 5.637 4.149 7.924 6.831zM55.299 72.514c.961-3.073 2.27-6.007 3.538-8.959 1.028-2.394 1.59-4.916 1.777-7.506.093-1.277.067-2.57.004-3.851-.071-1.423-.185-2.85-.392-4.259-.266-1.801-.569-3.603-.995-5.371-.462-1.913-1.627-3.245-3.623-3.736-1.216-.299-2.424-.287-3.653-.093-3.002.473-5.75 1.579-8.31 3.199-.515.326-.798.589-.709 1.328.188 1.565.229 3.155.222 4.735-.01 2.236-.105 4.472-.19 6.707-.028.728-.133 1.452-.211 2.177-.12 1.11-.351 2.219-.344 3.327.007 1.142.124 2.311.401 3.417.88 3.507 2.744 6.377 5.799 8.402 1.879 1.245 3.958 1.873 6.24 1.992.155-.524.293-1.019.446-1.509zm-3.586-30.087c-.402-.844-.172-1.543.76-1.867.227-.08.461-.165.697-.188.324-.032.654-.008.982-.008 1.182.006 2.319.171 3.295.923.626.482.794 1.122.389 1.779-.575.932-1.452 1.4-2.529 1.49-1.697.141-2.888-.65-3.594-2.129zM98.753 42.119c.136-1.124.245-2.251.384-3.375.056-.452-.182-.574-.561-.585-1.192-.033-2.384-.075-3.576-.097-1.344-.024-2.652.192-3.896.703-1.38.568-2.431 1.478-2.86 2.98-.32 1.12-.406 2.239-.293 3.41.172 1.785.568 3.517 1.193 5.176.834 2.221 1.707 4.441 2.75 6.569 1.413 2.881 3.012 5.67 4.513 8.507.401.757.738 1.547 1.156 2.431.875-1.853 1.302-3.708 1.351-5.622.041-1.61-.088-3.227-.182-4.838-.059-.986-.198-1.966-.294-2.95-.134-1.371-.337-2.741-.368-4.115-.031-1.397.068-2.802.188-4.197.113-1.338.334-2.665.495-3.997zm-2.689-1.082c-.443 1.223-1.39 1.913-2.618 2.116-1.145.188-2.148-.235-2.894-1.148-.531-.65-.328-1.42.468-1.859.914-.506 1.919-.634 3.104-.711.322.059.807.108 1.268.24.669.189.916.692.672 1.362zM60.642 78.697c-.655-.535-1.521-.566-2.144.021-.773.73-1.453 1.565-2.133 2.388-.785.951-1.521 1.94-2.534 2.677-1.474 1.071-3.192 1.515-4.919 1.935-1.373.334-2.752.644-4.129.965l-.017.178c.409.189.805.425 1.231.56 2.1.665 4.236.996 6.455.808 1.602-.136 3.128-.485 4.574-1.171 1.99-.943 3.521-2.437 4.823-4.175.218-.29.317-.719.343-1.093.089-1.321-.582-2.303-1.55-3.093zM112.393 79.223c-1.69.181-3.382.373-5.077.47-.818.047-1.648-.109-2.474-.176-1.385-.112-2.737-.42-3.908-1.16-.678-.427-1.241-.475-1.961-.233-1.028.346-1.867.872-2.115 1.986-.169.753-.23 1.533-.298 2.304-.013.136.157.386.287.42.793.209 1.59.456 2.401.529.996.09 2.01.061 3.013.011 1.083-.054 2.173-.124 3.24-.304 2.515-.422 4.948-1.11 7.109-2.536.779-.515 1.551-1.041 2.325-1.562l-.064-.11c-.826.123-1.648.273-2.478.361z"
              ></path>
            </svg>
          </div>
        </div>
        <div id="contact-container">
          <Link to="/contact" id="contact-btn">
            Connect with me <i className="fas fa-chevron-circle-right"></i>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Bio;
